export var LocationType;
(function (LocationType) {
    LocationType["UNKNOWN_LOCATION_TYPE"] = "UNKNOWN_LOCATION_TYPE";
    /** A business location, either the default business address, or locations defined for the business by the Business Info. */
    LocationType["BUSINESS"] = "BUSINESS";
    /** The location is unique to this service and isn't defined as one of the business locations. */
    LocationType["CUSTOM"] = "CUSTOM";
    /** The location can be determined by the customer and is not set up beforehand. */
    LocationType["CUSTOMER"] = "CUSTOMER";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=types.impl.js.map